<section class="profile-card">
  <div class="row">
    <article class="card col">
      <h2 class="h4">{{ prefix + '-titel' | fromDictionary }}</h2>
      <p>
        @if (customer.displayName) {
          {{ customer.displayName }}
          <br />
        }
        @if (customer.email) {
          {{ customer.email }}
          <br />
        }
        @if (customer.phone) {
          {{ customer.phone }}
          <br />
        }
        @if (customer.metafield) {
          {{ 'label-BTW' | fromDictionary }}: {{ customer.metafield.value }}
          <br />
        }
      </p>

      <a [routerLink]="['/account/bewerken']" type="button" class="button button-link button--muted-light">
        <app-icon anchor="icon-edit"></app-icon>
        <span class="button__label">{{ prefix + '-bewerken' | fromDictionary }}</span>
      </a>
    </article>

    @if (!hasVatNumber && hasAdress) {
      <app-alert class="d-block col-md-5 ms-md-3" [title]="'profiel-overzicht-geen-btw-titel' | fromDictionary" [status]="'type--info'">
        <p class="my-3">{{ 'profiel-overzicht-geen-btw-tekst' | fromDictionary }}</p>
        <a class="button button--light button--sm" [routerLink]="['/account/bewerken']">
          {{ 'profiel-overzicht-geen-btw-knop-label' | fromDictionary }}
        </a>
      </app-alert>
    }
  </div>
</section>
